import { render, staticRenderFns } from "./NewsScreen.vue?vue&type=template&id=95e8fc9c&scoped=true&"
import script from "./NewsScreen.vue?vue&type=script&lang=ts&"
export * from "./NewsScreen.vue?vue&type=script&lang=ts&"
import style0 from "./NewsScreen.vue?vue&type=style&index=0&id=95e8fc9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e8fc9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
